var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeaf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 504.123 504.123",
    style: {
      enableBackground: "new 0 0 504.123 504.123"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A7F0D"
    },
    d: "M235.733,0c0,0,29.594,22.662-10.87,73.169c-22,27.427-27.475,68.017,23.662,95.815 c-9.082-20.48-24.639-68.277,9.389-101.155c0,0-28.861,35.415,4.435,99.864c20.543-8.444,66.111-32.689,56.737-79.045 C306.696,27.388,235.733,0,235.733,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#49A010"
    },
    d: "M262.215,167.416c30.901-39.66,38.187-94.46,15.927-141.816C256.922,8.2,235.725,0,235.725,0 s29.594,22.662-10.87,73.169c-22,27.427-27.475,68.017,23.662,95.815c-9.082-20.48-24.639-68.277,9.389-101.155 C257.914,67.828,229.148,103.14,262.215,167.416z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#3A7F0D"
    },
    cx: 195.104,
    cy: 86.835,
    r: 4.372
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#49A010"
    },
    cx: 204.729,
    cy: 76.154,
    r: 3.127
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#49A010"
    },
    cx: 187.376,
    cy: 52.011,
    r: 7.79
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#49A010"
    },
    cx: 217.056,
    cy: 55.225,
    r: 2.489
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#49A010"
    },
    d: "M234.189,28.956c1.993,3.434,0.851,7.814-2.576,9.815c-3.419,1.985-7.806,0.843-9.807-2.584 c-1.993-3.403-0.835-7.798,2.576-9.799C227.793,24.387,232.196,25.537,234.189,28.956z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A7F0D"
    },
    d: "M268.39,504.123c0,0-29.601-22.662,10.87-73.169c21.992-27.427,27.475-68.017-23.67-95.815 c9.09,20.48,24.647,68.261-9.381,101.14c0,0,28.853-35.399-4.435-99.848c-20.543,8.444-66.103,32.689-56.737,79.045 C197.427,476.735,268.39,504.123,268.39,504.123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#49A010"
    },
    d: "M241.908,336.691c-30.909,39.66-38.187,94.476-15.935,141.816 c21.228,17.416,42.425,25.616,42.425,25.616s-29.601-22.662,10.87-73.169c21.992-27.427,27.475-68.017-23.67-95.815 c9.09,20.48,24.647,68.261-9.381,101.14C246.209,436.279,274.976,400.967,241.908,336.691z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#3A7F0D"
    },
    cx: 309.012,
    cy: 417.319,
    r: 4.364
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#49A010"
    },
    cx: 299.402,
    cy: 427.961,
    r: 3.127
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#49A010"
    },
    cx: 316.731,
    cy: 452.112,
    r: 7.798
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#49A010"
    },
    cx: 287.067,
    cy: 448.906,
    r: 2.497
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#49A010"
    },
    cx: 276.086,
    cy: 471.513,
    r: 7.176
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A7F0D"
    },
    d: "M418.745,62.275c0,0,4.907,36.951-59.431,44.064c-34.942,3.828-67.513,28.664-51.011,84.496 c8.05-20.921,30.846-65.709,78.155-64.89c0,0-45.442,4.632-67.466,73.736c20.504,8.554,69.853,23.631,96.004-15.77 C449.56,131.828,418.745,62.275,418.745,62.275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#49A010"
    },
    d: "M319.094,199.396c49.892-6.199,93.791-39.802,111.537-89.033 c-2.702-27.309-11.886-48.089-11.886-48.089s4.907,36.951-59.431,44.064c-34.942,3.828-67.513,28.664-51.011,84.496 c8.05-20.921,30.846-65.709,78.155-64.89C386.458,125.936,341.157,130.568,319.094,199.396z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#3A7F0D"
    },
    cx: 328.609,
    cy: 94.956,
    r: 4.364
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#49A010"
    },
    cx: 342.977,
    cy: 94.216,
    r: 3.119
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#49A010"
    },
    cx: 347.766,
    cy: 64.859,
    r: 7.798
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#49A010"
    },
    d: "M368.9,88.757c-0.347,1.339-1.717,2.135-3.04,1.788c-1.339-0.354-2.135-1.709-1.788-3.064 c0.354-1.308,1.709-2.111,3.041-1.772C368.443,86.063,369.254,87.434,368.9,88.757z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#49A010"
    },
    cx: 390.239,
    cy: 79.856,
    r: 7.168
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A7F0D"
    },
    d: "M85.378,441.832c0,0-4.915-36.935,59.424-44.048c34.942-3.844,67.521-28.664,51.019-84.496 c-8.058,20.905-30.846,65.709-78.155,64.89c0,0,45.442-4.632,67.458-73.736c-20.496-8.57-69.853-23.631-96.004,15.754 C54.563,372.295,85.378,441.832,85.378,441.832z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#49A010"
    },
    d: "M185.029,304.727c-49.892,6.199-93.798,39.802-111.537,89.017 c2.71,27.325,11.886,48.089,11.886,48.089s-4.915-36.943,59.424-44.048c34.942-3.844,67.521-28.664,51.019-84.496 c-8.058,20.905-30.846,65.709-78.155,64.89C117.665,378.187,162.966,373.555,185.029,304.727z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#3A7F0D"
    },
    cx: 175.514,
    cy: 409.206,
    r: 4.372
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#49A010"
    },
    cx: 161.146,
    cy: 409.915,
    r: 3.119
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#49A010"
    },
    cx: 156.349,
    cy: 439.296,
    r: 7.79
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#49A010"
    },
    cx: 137.633,
    cy: 415.98,
    r: 2.497
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#49A010"
    },
    cx: 113.885,
    cy: 424.251,
    r: 7.168
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A7F0D"
    },
    d: "M504.123,235.725c0,0-22.662,29.601-73.177-10.862c-27.427-22-68.009-27.475-95.815,23.678 c20.488-9.106,68.277-24.647,101.148,9.366c0,0-35.399-28.861-99.848,4.443c8.444,20.535,32.689,66.111,79.045,56.737 C476.727,306.696,504.123,235.725,504.123,235.725z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#49A010"
    },
    d: "M336.699,262.215c39.66,30.893,94.452,38.187,141.816,15.919 c17.4-21.213,25.608-42.409,25.608-42.409s-22.662,29.601-73.177-10.862c-27.427-22-68.009-27.475-95.815,23.678 c20.488-9.106,68.277-24.647,101.148,9.366C436.279,257.906,400.951,229.155,336.699,262.215z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#3A7F0D"
    },
    cx: 417.28,
    cy: 195.111,
    r: 4.356
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#49A010"
    },
    cx: 427.953,
    cy: 204.721,
    r: 3.127
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#49A010"
    },
    d: "M456.042,194.095c-3.718,2.182-8.476,0.922-10.665-2.788c-2.166-3.742-0.922-8.507,2.788-10.665 c3.718-2.182,8.483-0.937,10.658,2.788C461.013,187.14,459.76,191.905,456.042,194.095z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#49A010"
    },
    cx: 448.898,
    cy: 217.009,
    r: 2.497
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#49A010"
    },
    d: "M475.152,234.197c-3.434,1.985-7.798,0.843-9.799-2.584c-1.993-3.403-0.851-7.814,2.568-9.815 c3.419-1.985,7.814-0.827,9.807,2.568C479.72,227.801,478.578,232.204,475.152,234.197z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A7F0D"
    },
    d: "M0,268.383c0,0,22.654-29.601,73.169,10.878c27.412,21.984,68.017,27.475,95.815-23.678 c-20.48,9.106-68.277,24.647-101.14-9.381c0,0,35.399,28.861,99.832-4.427c-8.428-20.551-32.673-66.111-79.029-56.737 C27.388,197.427,0,268.383,0,268.383z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#49A010"
    },
    d: "M167.416,241.892c-39.66-30.893-94.46-38.172-141.816-15.911C8.2,247.217,0,268.383,0,268.383 s22.654-29.601,73.169,10.878c27.412,21.984,68.017,27.475,95.815-23.678c-20.48,9.106-68.277,24.647-101.14-9.381 C67.844,246.201,103.148,274.983,167.416,241.892z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#3A7F0D"
    },
    cx: 86.804,
    cy: 309.02,
    r: 4.372
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#49A010"
    },
    cx: 76.146,
    cy: 299.386,
    r: 3.119
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#49A010"
    },
    d: "M48.073,310.012c3.718-2.166,8.483-0.906,10.665,2.812c2.166,3.71,0.922,8.476-2.788,10.65 c-3.718,2.182-8.483,0.922-10.665-2.788C43.095,316.967,44.363,312.202,48.073,310.012z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#49A010"
    },
    cx: 55.217,
    cy: 287.059,
    r: 2.497
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#49A010"
    },
    cx: 32.579,
    cy: 276.133,
    r: 7.168
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A7F0D"
    },
    d: "M441.84,418.737c0,0-36.943,4.907-44.056-59.431c-3.836-34.942-28.664-67.505-84.496-51.003 c20.913,8.042,65.709,30.846,64.89,78.155c0,0-4.632-45.45-73.736-67.474c-8.562,20.512-23.639,69.86,15.77,96.012 C372.295,449.552,441.84,418.737,441.84,418.737z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#49A010"
    },
    d: "M304.727,319.094c6.199,49.892,39.802,93.783,89.017,111.537 c27.309-2.71,48.096-11.894,48.096-11.894s-36.943,4.907-44.056-59.431c-3.836-34.942-28.664-67.505-84.496-51.003 c20.913,8.042,65.709,30.846,64.89,78.155C378.187,386.458,373.547,341.157,304.727,319.094z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#3A7F0D"
    },
    cx: 409.159,
    cy: 328.625,
    r: 4.364
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#49A010"
    },
    d: "M409.12,345.986c-1.67-0.433-2.655-2.135-2.221-3.781c0.433-1.678,2.135-2.678,3.789-2.245 c1.67,0.449,2.678,2.135,2.237,3.828C412.475,345.435,410.782,346.443,409.12,345.986z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#49A010"
    },
    cx: 439.257,
    cy: 347.766,
    r: 7.79
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#49A010"
    },
    d: "M415.358,368.908c-1.339-0.354-2.127-1.725-1.796-3.048c0.362-1.339,1.725-2.135,3.072-1.788 c1.315,0.354,2.111,1.709,1.764,3.033C418.06,368.443,416.681,369.262,415.358,368.908z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#49A010"
    },
    cx: 424.267,
    cy: 390.223,
    r: 7.168
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A7F0D"
    },
    d: "M62.283,85.37c0,0,36.935-4.907,44.04,59.431c3.844,34.942,28.68,67.521,84.504,51.019 c-20.913-8.042-65.701-30.846-64.882-78.155c0,0,4.632,45.434,73.736,67.458c8.554-20.496,23.631-69.86-15.762-96.012 C131.828,54.556,62.283,85.37,62.283,85.37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#49A010"
    },
    d: "M199.396,185.029c-6.199-49.892-39.81-93.798-89.033-111.537 C83.046,76.201,62.283,85.37,62.283,85.37s36.935-4.907,44.04,59.431c3.844,34.942,28.68,67.521,84.504,51.019 c-20.913-8.042-65.701-30.846-64.882-78.155C125.936,117.665,130.56,162.966,199.396,185.029z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#3A7F0D"
    },
    cx: 94.917,
    cy: 175.498,
    r: 4.364
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#49A010"
    },
    cx: 94.216,
    cy: 161.146,
    r: 3.127
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#49A010"
    },
    cx: 64.851,
    cy: 156.349,
    r: 7.798
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#49A010"
    },
    cx: 88.119,
    cy: 137.633,
    r: 2.497
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#49A010"
    },
    cx: 79.84,
    cy: 113.885,
    r: 7.168
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf);
export default __webpack_public_path__ + "static/media/leaf.55259ab7d98f094c47ea2b5398eab7b7.svg";
export { ForwardRef as ReactComponent };